import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-content px-6 py-5" }

import { ref } from 'vue';
  import { Dialog } from 'vant';

  interface Props {
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    title: { default: '确认操作' },
    message: {},
    confirmText: { default: '确认' },
    cancelText: { default: '取消' }
  },
  setup(__props: any, { expose: __expose }) {

  

  const visible = ref(false);
  const resolvePromise = ref<((value: boolean) => void) | null>(null);

  const show = (): Promise<boolean> => {
    visible.value = true;
    return new Promise((resolve) => {
      resolvePromise.value = resolve;
    });
  };

  const handleConfirm = () => {
    visible.value = false;
    resolvePromise.value?.(true);
    resolvePromise.value = null;
  };

  const handleCancel = () => {
    visible.value = false;
    resolvePromise.value?.(false);
    resolvePromise.value = null;
  };

  __expose({
    show,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    show: visible.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: _ctx.title || '确认操作',
    width: "min(400px, 92vw)",
    teleport: "body",
    "show-cancel-button": "",
    "confirm-button-text": _ctx.confirmText || '确认',
    "cancel-button-text": _ctx.cancelText || '取消',
    "confirm-button-color": "#dc2626",
    "close-on-click-overlay": false,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    _: 1
  }, 8, ["show", "title", "confirm-button-text", "cancel-button-text"]))
}
}

})